import { configuratorInterface } from '../systems/configurator-interface.js'
import { webComponentProperties } from './web-component-properties.js'

/**
 * Register custom web component properties for Shopify integration.
 */
export default configuratorInterface.createGetWebComponentOptionsHandler(() => ({
  properties: webComponentProperties,
}))
